export default "__VITE_ASSET__9837ea88__"